__turbopack_context__.v({
  "container": "style-module-scss-module__xByZ3a__container",
  "content": "style-module-scss-module__xByZ3a__content",
  "mainWrapper": "style-module-scss-module__xByZ3a__mainWrapper",
  "sidebarSeparator": "style-module-scss-module__xByZ3a__sidebarSeparator",
  "sidebarWrapper": "style-module-scss-module__xByZ3a__sidebarWrapper",
  "tocWrapper": "style-module-scss-module__xByZ3a__tocWrapper",
});
